import axios from 'axios';
import * as endpoints from './const';

class DocumentApi {
  static add = (urlEndpoint, file, fileProgressFn) => {
    const conf = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: progressEvent => {
        const { loaded, total } = progressEvent;
        const progressVal = Math.round((loaded / total) * 100);
        fileProgressFn(progressVal);
      },
    };

    const formdata = new FormData();
    formdata.append('file', file);
    return axios
      .post(urlEndpoint, formdata, conf)
      .then(resp => resp.data)
      .then(data => data)
      .catch(err => console.error(err));
  };

  static delete = urlEndpoint => {
    return axios.delete(urlEndpoint);
  };

  static downloadWithUrl = (fileLoc, fileName) => {
    axios({
      url: fileLoc,
      method: 'GET',
      responseType: 'blob',
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    });
  };
}

export default DocumentApi;



// WEBPACK FOOTER //
// ./src/api/DocumentApi.js